import { Clipboard } from '@capacitor/clipboard';

export const writeToNativeClipboard = async (clipboardText: string): Promise<void> => {
    await Clipboard.write({
        string: clipboardText,
    });
};

export const readFromNativeClipboard = async (): Promise<string> => {
    const { value } = await Clipboard.read();
    return value;
};
